import { FlatGraphNode } from '@components';

export interface StatusGraphNodeData {
  label: string;
  statusType: GraphStatusType;
  statusTypeID: number;
  order?: number;
}

export enum GraphStatusType {
  Open = 'open',
  InProgress = 'in progress',
  OnHold = 'on-hold',
  Completed = 'completed',
}

export type StatusGraphNode = FlatGraphNode<StatusGraphNodeData>;

export const statusGraphTypeIdMap: Record<GraphStatusType, number> = {
  [GraphStatusType.Open]: 1,
  [GraphStatusType.InProgress]: 2,
  [GraphStatusType.OnHold]: 3,
  [GraphStatusType.Completed]: 4,
};
